import { React, useState } from "react";
import double_arrow from "../../Assets/img/icons/double-arrow.png";
import styles from "./walletRadarAddresses.module.css";

export function WalletRadarAddressesComponent({ element }) {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <>
      <div
        className={` card__wallet__row ${styles.walletRadarAddressesComponent}`}
      >
        <div className="card__wallet__rates cart__walet__text__title">
          <span>
            {+element?.balance
              ? new Intl.NumberFormat("en-US").format(
                  (+element?.balance).toFixed(2)
                )
              : 0}{" "}
          </span>
          <span>{element?.account}</span>
        </div>
        <div className="card__wallet__usd cart__walet__text__title">
          ${" "}
          {element?.usdPrice
            ? new Intl.NumberFormat("en-US").format(
                Math.round(element?.usdPrice)
              )
            : 0}
        </div>
        <div
          className={`${styles.double_arrow} ${
            isExpanded ? styles.rotate : ""
          }`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
        >
          <img src={double_arrow} alt="Toggle" />
        </div>
      </div>

      {/* <div
        className="card__product__wrapper"
        style={{ paddingTop: "5px", position: "relative" }}
      >
        <div>
          <div
            className={` ${styles.staking_card_product_scroller} 
              ${isExpanded ? styles.expanded : ""}`}
            style={{ height: zoomActive && isExpanded ? "325px" : null }}
          >
            {element.stakingRisk.stakingRiskClassifications.map(
              (item, index) => (
                <div
                  key={index}
                  className="card_product_scroller_item"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "8px 0",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                >
                  <p
                    className={`${styles.staking_card_product_title} "card_product_scroller_item_title"}`}
                    title={item.name}
                  >
                    {item.name.length > 15
                      ? item.name.slice(0, 15) + "…"
                      : item.name}
                  </p>
                  <p
                    className={`${styles.staking_card_product_level} "card_product_scroller_item_level"}`}
                    style={{
                      color: rendeColorClassName(
                        item.riskScoreType === "manual"
                          ? item.manualScoreLevel
                          : item.automaticScoreLevel
                      )?.color,
                    }}
                  >
                    {(item.riskScoreType === "manual"
                      ? item.manualScoreLevel
                      : item.automaticScoreLevel
                    )
                      ?.replace("Risk", "")
                      .trim()}
                  </p>
                </div>
              )
            )}
          </div>
          <div
            className={`${styles.double_arrow} ${
              isExpanded ? styles.rotate : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            }}
          >
            <img src={double_arrow} alt="Toggle" />
          </div>
        </div>
      </div> */}
    </>
  );
}
